'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
import { FileErrorType } from '@application/enums/file-error-type';
import { getFileIcon } from '@application/utilities/fileUploaderHelper';
const FileUploadContext = createContext(undefined);
export const FileUploadProvider = ({ children }) => {
    const [fileError, setFileError] = useState({
        hasError: false,
        errorType: FileErrorType.NoError
    });
    const [attachments, setAttachments] = useState([
        {
            id: 1,
            title: 'Event Program',
            fileName: 'Proposal.pdf',
            icon: 'custom:pdf-icon',
            invited: 'John Doe',
            addedOn: '2025-07-17'
        },
        {
            id: 2,
            title: 'Event Program',
            fileName: 'Proposal.pdf',
            icon: 'custom:pdf-icon',
            invited: 'Jane Smith',
            addedOn: '2025-07-15'
        }
    ]);
    const addAttachments = (files, title) => {
        const newRows = files.map((file, index) => ({
            id: Date.now() + index,
            title,
            fileName: file.name,
            icon: getFileIcon(file),
            invited: 'You',
            addedOn: new Date().toISOString().split('T')[0],
            file
        }));
        setAttachments((prev) => [...prev, ...newRows]);
    };
    const removeAttachment = (id) => {
        setAttachments((prev) => prev.filter((attachment) => attachment.id !== id));
    };
    const clearAttachments = () => {
        setAttachments([]);
    };
    return (_jsx(FileUploadContext.Provider, { value: {
            fileError,
            setFileError,
            attachments,
            addAttachments,
            removeAttachment,
            clearAttachments
        }, children: children }));
};
export const useFileUpload = () => {
    const context = useContext(FileUploadContext);
    if (context === undefined) {
        throw new Error('useFileUpload must be used within a FileUploadProvider');
    }
    return context;
};
export const useFileUploadOptional = () => {
    return useContext(FileUploadContext);
};
